import styled from 'styled-components';
import {EMPHASIS} from '@forecast-it/design-system';
import {LabelledButton} from '../LabelledButton';

interface Props {
	message: string | null;
	onDismiss: () => void;
}

const Toast = styled.div`
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 50;
	display: flex;
	align-items: center;
	gap: 12px;
	border-radius: 8px;
	background: #0f172a;
	padding: 12px 16px;
	${p => p.theme.sys.font?.subheading?.['2']}
	color: #ffffff;
	box-shadow: 0 4px 12px rgb(15 23 42 / 0.1);
`;

export function BoardToast({message, onDismiss}: Props) {
	if (!message) return null;
	return (
		<Toast role="alert">
			<span>{message}</span>
			<LabelledButton emphasis={EMPHASIS.LOW} onPress={onDismiss} label="Dismiss">
				×
			</LabelledButton>
		</Toast>
	);
}
